import './CharacterName.css';
import claudiImg from './claudi.png';
import eddyImg from './eddy.png';
import rockImg from './rock.png';
import tuchiImg from './tuchi.png';
import ufoImg from './ufo.png';
import vallImg from './vall.png';

const CHARACTER_NAME_IMAGES = {
  claudi: claudiImg,
  eddy: eddyImg,
  rock: rockImg,
  tuchi: tuchiImg,
  ufo: ufoImg,
  vall: vallImg,
} as const;

export type CharacterNameId = keyof typeof CHARACTER_NAME_IMAGES;

export type CharacterNameProps = {
  name: CharacterNameId;
  /** Figma AABB left (screen coords). */
  left: number;
  /** Figma AABB top (screen coords). */
  top: number;
  /** Figma AABB width — used to center the upright PNG. */
  width: number;
  /** Figma AABB height — used to center the upright PNG. */
  height: number;
  /** Rotation in degrees (tilt baked into Figma vectors). */
  rotation?: number;
  className?: string;
};

/** Character name sticker from Figma Group 1321317891 (121:19911). */
export function CharacterName({
  name,
  left,
  top,
  width,
  height,
  rotation = 0,
  className,
}: CharacterNameProps) {
  return (
    <img
      className={['character-name', className].filter(Boolean).join(' ')}
      src={CHARACTER_NAME_IMAGES[name]}
      alt=""
      draggable={false}
      style={{
        left: left + width / 2,
        top: top + height / 2,
        transform: `translate(-50%, -50%) rotate(${rotation}deg)`,
      }}
    />
  );
}
